import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.homeCarousel = this.el;
        this.homeCarousel.style.setProperty('--progress', 0);
        this.nav = document.querySelector('.home-nav');
        this.count = this.homeCarousel.style.getPropertyValue('--items');
    }

    init() {
        if (this.count < 3) return;

        window.addEventListener('homeProgress', (e) => {
            const { target, progress } = e.detail;
            // console.log(`target: ${target}`, `progress: ${progress}`);
            this.homeCarousel.style.setProperty('--progress', progress);

            // if (progress > 0 && progress < 1) {
            //     this.nav.classList.add('-visible');
            // } else {
            //     this.nav.classList.remove('-visible');
            // }
        });
    }
}
